// Shared neumorphic platform/social button -- the ONE reusable component
// for every external platform link across the site (Official Brand
// Presence, Founder artist platforms, Follow Us). Renders a real,
// working anchor when a URL is configured; otherwise a clearly disabled
// "Coming Soon" state. No sliding-line or shine hover effects.
const PlatformButton = ({ href, label, icon: Icon, testId }) => {
  const disabled = !href;

  if (disabled) {
    return (
      <span
        data-testid={testId}
        aria-label={`${label} coming soon`}
        title={`${label} coming soon`}
        className="platform-btn platform-btn-disabled"
      >
        <Icon size={20} />
        <span className="text-small font-semibold">{label}</span>
        <span className="platform-btn-badge">Coming Soon</span>
      </span>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label={`${label} (opens in a new tab)`}
      className="platform-btn"
    >
      <Icon size={20} />
      <span className="text-small font-semibold">{label}</span>
    </a>
  );
};

export default PlatformButton;
